// Dropdown Icon
const DropdownIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const FormSelect = ({
  label,
  name,
  value,
  onChange,
  options = [],
  required = false,
  helperText = '',
  placeholder = false
}) => {
  const selectClass = "w-full px-5 py-3 pr-12 rounded-xl bg-jp-section backdrop-blur-md border border-jp-line text-jp-ink appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-cyan-400/50 transition-all";

  return (
    <div>
      <label className="block text-left text-jp-ink text-sm font-roboto mb-3">
        {label} {helperText && <span className="text-jp-muted text-xs">{helperText}</span>}
      </label>
      <div className="relative">
        <select
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          className={selectClass}
        >
          {placeholder && <option value=""></option>}
          {options.map((option, i) => (
            <option key={i} value={option}>
              {option}
            </option>
          ))}
        </select>
        {/* <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-jp-ink">
          <DropdownIcon />
        </div> */}
      </div>
    </div>
  );
};

export default FormSelect;
